<app-kontable
        id="dt_toponym"
        [source]="srvToponym.toponyms"
        [title]="'toponymList.sectionTitle' | translate"
        [columns]="['id', 'name']"
        [titles]="['common.id', 'common.name']"
        [showInfoButton]="false"
        [showGlobalFilter]="false"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        (onAdd)="showAddOrEditDialog(null)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)"
>
</app-kontable>

<p-dialog
        *ngIf="srvToponym.toponymEditing"
        [(visible)]="srvToponym.toponymEditing"
        [modal]="true"
        [resizable]="false"
        header="{{modalTitle}}"
        [draggable]="false"
        [width]="500"
        (onHide)="closeAddDialog()">
    <app-toponym-form
            (toponymAdded)="toponymAdded($event)"
            (toponymUpdated)="toponymUpdated($event)"
            [dialogBoxToponym]="srvToponym.toponymEditing"
    ></app-toponym-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/toponym/toponym.component.html